export type FeedbackOption = {
  id: string;
  description: string;
};

export const DISAPPOINTING_NEWS_OPTIONS: FeedbackOption[] = [
  {
    id: 'disappointing_news_not_related_seller',
    description: '셀러와 관련이 없어요',
  },
  {
    id: 'disappointing_news_too_short_or_lacking',
    description: '내용이 짧거나 부실해요',
  },
  {
    id: 'disappointing_news_hard_to_understand',
    description: '이해하기 어려워요',
  },
  {
    id: 'disappointing_news_not_my_interest',
    description: '내 관심 분야가 아니에요',
  },
  {
    id: 'disappointing_news_other_category',
    description: '다른 카테고리의 뉴스도 보고싶어요',
  },
];
